function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import PropTypes from 'prop-types';
import React from 'react';
import LinkButton from './LinkButton';
import Popover from './Popover';
import Text from './Text';
const ConfirmPopover = /*#__PURE__*/React.memo(_ref => {
  let {
    cancelText = 'Cancel',
    children,
    confirmText = 'Confirm',
    isOpen,
    onConfirm,
    onCancel,
    text = 'Are you sure?',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Popover, _extends({
    referenceComponent: () => children,
    isOpen: isOpen,
    onClose: onCancel
  }, props), /*#__PURE__*/React.createElement(Text, {
    mb: 1,
    textAlign: "center"
  }, text), /*#__PURE__*/React.createElement(Text, {
    textAlign: "center"
  }, /*#__PURE__*/React.createElement(LinkButton, {
    onClick: onConfirm,
    mr: 3,
    sx: {
      cursor: 'pointer',
      color: 'primary',
      ':hover,:focus': {
        color: 'primaryLighten'
      }
    },
    fontWeight: "bold"
  }, confirmText), /*#__PURE__*/React.createElement(LinkButton, {
    onClick: onCancel,
    sx: {
      cursor: 'pointer',
      color: 'gray.5',
      ':hover,:focus': {
        color: 'gray.4'
      }
    },
    fontWeight: "bold"
  }, cancelText)));
});
ConfirmPopover.propTypes = {
  ...Popover.propTypes,
  cancelText: PropTypes.string,
  children: PropTypes.any,
  confirmText: PropTypes.string,
  isOpen: PropTypes.bool,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
  text: PropTypes.string
};
ConfirmPopover.displayName = 'ConfirmPopover';
export default ConfirmPopover;